module.exports = __webpack_public_path__ + "media/tr_tr_s2_Ergin.cf17c731.mp3";